import { CREATE_BLOG_CATEGORY, DELETE_BLOG_CATEGORY, UPDATE_BLOG_CATEGORY } from "../../../../utils/keywords"
import { retrieveAllBlogCategories } from "../../../../redux/admin-slices/blogs.slice"
import { showDialogWithData } from "../../../../redux/guest-slices/other.slice"
import TablePagination from "../../../../components/common/PaginationSkell"
import EntriesSelect from "../../../../components/ui/EntriesSelect"
import TableSkell from "../../../../components/common/TableSkell"
import InputFieldA from "../../../../components/ui/InputFieldA"
import { useDispatch, useSelector } from "react-redux"
import { debounce } from "../../../../utils/helper"
import { useEffect, useRef, useState } from "react"
import Icons from "../../../../assets/js/Icons"


import {
  Box, Button, Container, Grid2 as Grid, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography
} from "@mui/material"

function BlogCategories() {
  const searchRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const { refresh, loadings } = useSelector(state => state.otherSlice)

  // handle create category
  const handleCreate = () => {
    dispatch(showDialogWithData({ type: CREATE_BLOG_CATEGORY }))
  }

  // handle delete category
  const handleDelete = (categoryId) => {
    dispatch(showDialogWithData({ type: DELETE_BLOG_CATEGORY, data: { categoryId } }))
  }

  // handle update category
  const handleUpdate = (category) => {
    dispatch(showDialogWithData({
      data: { category },
      type: UPDATE_BLOG_CATEGORY,
    }))
  }

  // Handle retrieve all FAQs
  const handleRetrieveAll = (filters) => {
    dispatch(retrieveAllBlogCategories({
      search: searchRef?.current?.value || null,
      limit: entriesRef?.current?.value || null,
      currentPage: filters?.currentPage || null,
    })
    ).unwrap().then((data) => {
      setData(data)
    }).catch(() => { })
  }

  // Handle search FAQs
  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()

    // eslint-disable-next-line
  }, [refresh])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Blog Categories</Typography>
        <Button
          variant="outlined"
          onClick={handleCreate}
          startIcon={<Icons.PlusSolid />}
        >Add Category
        </Button>
      </Box>

      <Grid container spacing={1} className="filters-grid" justifyContent="space-between">
        <Grid size={{ xs: 12, sm: 8, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
            placeholder="Search with names"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Name", "Slug", "Action"]?.map((cell, i) => (
                  <TableCell key={i} align="left">{cell}</TableCell>
                ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ?
                <TableSkell colLength={3} /> :
                data?.records?.map((element, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{ "td": { borderBottomWidth: i === (data?.records?.length - 1) ? "0" : "1px" } }}
                  >
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.name}</TableCell>
                    <TableCell>{element?.slug}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        sx={{ mr: 1 }}
                        onClick={() => { handleUpdate(element) }}
                      ><Icons.EditSolid />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => { handleDelete(element?._id) }}
                      ><Icons.DeleteSolid />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }

              {(!data?.records?.length && !loadings?.retrieveAll) &&
                <TableRow sx={{ "td": { borderBottom: "none" } }}>
                  <TableCell colSpan={3}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
        />
      </Box>
    </Container>
  )
}

export default BlogCategories